

export const initOverlay = (map: any, distance: string = '5', center: any, icon: any)=>{
    function drawCircle(point: any, radius: any, dir: any) {
        const d2r = Math.PI / 180; // degrees to radians
        const r2d = 180 / Math.PI; // radians to degrees
        const earthsradius = 6371; // 3963 is the radius of the earth in km
        const points = 32;
        // find the raidus in lat/lon
        const rlat = (radius / earthsradius) * r2d;
        const rlng = rlat / Math.cos(point.lat() * d2r);

        const extp: any = [];
        let end;
        let start;
        if (dir==1) {
            start = 0;
            end=points+1; // one extra here makes sure we connect the path
        } else {
            start=points+1;
            end=0;
        }
        for (let i=start; (dir==1 ? i < end : i > end); i=i+dir) {
            const theta = Math.PI * (i / (points/2));
            const ey = point.lng() + (rlng * Math.cos(theta)); // center a + radius x * cos(theta)
            const ex = point.lat() + (rlat * Math.sin(theta)); // center b + radius y * sin(theta)
            extp.push(new google.maps.LatLng(ex, ey));
        }
        return extp;
    }
    if (!!map && map?.getBounds()) {
        const lineSymbol = {
            path: 'M 0,-1 0,1',
            strokeOpacity: 1,
            scale: 2,
        };
        let radius;
        if (distance == '5') {
            radius = 0.5;
        } else if ( distance === '10') {
            radius = 1;
        } else if (distance == '30') {
            radius = 3;
        }
        const path = [drawCircle(new google.maps.LatLng(center), radius, 1)];
        // console.log(path[0][8]);
        const lat = path[0][8]?.lat();
        const lng = path[0][8]?.lng();
        const polylineDotted = new google.maps.Polyline({
            strokeColor: '#000000',
            strokeOpacity: 0,
            icons: [{
                icon: lineSymbol,
                offset: '0',
                repeat: '10px',
            }],
            path: path.pop(),
            map: map,
        });
        let distanceMarker;
        if (!!lat && !!lng) {
            distanceMarker= new google.maps.Marker({
                position: {lat: lat, lng: lng},
                map: map,
                icon: {
                    url: icon,
                    scaledSize: new google.maps.Size(2*map.getZoom(), 2*map.getZoom()),
                },
                optimized: true,
            });
        }
        return {polylineDotted, distanceMarker};
    }
};
